// @flow

import { PlaceholderListContainer } from 'src/Domain/Placeholder/PlaceholderListContainer';
import { ProvidedPlaceholderRow } from 'src/Domain/Placeholder/ProvidedPlaceholderRow';

type Props = {
  searchValues: Array<string>,
};

export default function PlaceholderList({
  searchValues,
}: Props): React.MixedElement {
  return (
    <PlaceholderListContainer>
      {searchValues.map(item => (
        <ProvidedPlaceholderRow
          key={`provided-placeholder-${item}`}
          fqdn={item}
        />
      ))}
    </PlaceholderListContainer>
  );
}
